import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class Professionnels extends React.Component {
  render() {
  	
    return (
    	<I18n ns="translations">
        {
          (t, { i18n }) => (
				<section id="pros-intro-section">
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center">
									<div className="head-part">
										<h1>{t('prostitle')}</h1>
										<p ><span className="line-color"></span>{t('pros1')}<span className="line-color"></span></p>
										<h2 className="image-heading">{t('retailers')}</h2>
										<img className="img-circle head-img" src="images/img-pro-vin.png"/>
									</div>
								</div>
							</div>

							<div className="row desc-part">
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
											<div className="row">
												<div className="col-md-3 col-sm-3 col-xs-12 text-center white-img">
													<img src="images/ic-pro-white-01.png"/>
												</div>
												<div className="col-md-9 col-sm-9 col-xs-12 retailer-content">
													<p>{t('prosp1')} </p>
												</div>
											</div>								
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
											<div className="row">
												<div className="col-md-3 col-sm-3 col-xs-12 text-center white-img">
													<img src="images/ic-pro-white-02.png"/>
												</div>
												<div className="col-md-9 col-sm-9 col-xs-12 retailer-content">
													<p>{t('prosp2')}</p>
												</div>
											</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
											<div className="row">
												<div className="col-md-3 col-sm-3 col-xs-12 text-center white-img">
													<img src="images/ic-pro-white-03.png"/>
												</div>
												<div className="col-md-9 col-sm-9 col-xs-12 retailer-content">
													<p>{t('prosp3')}</p>
												</div>
											</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
											<div className="row">
												<div className="col-md-3 col-sm-3 col-xs-12 text-center white-img">
													<img src="images/ic-pro-white-04.png"/>
												</div>
												<div className="col-md-9 col-sm-9 col-xs-12 retailer-content">
													<p>{t('prosp4')}</p>
												</div>
											</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
											<div className="row">
												<div className="col-md-3 col-sm-3 col-xs-12 text-center white-img">
													<img src="images/ic-pro-white-05.png"/>
												</div>
												<div className="col-md-9 col-sm-9 col-xs-12 retailer-content">
													<p>{t('prosp5')}</p>
												</div>
											</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
											<div className="row">
												<div className="col-md-3 col-sm-3 col-xs-12 text-center white-img">
													<img src="images/ic-pro-white-06.png"/>
												</div>
												<div className="col-md-9 col-sm-9 col-xs-12 retailer-content">
													<p>{t('prosp6')}</p>
												</div>
											</div>
								</div>
							</div>

							
						</div>
						<div className="container-fluid">
							<div className="row comment-part text-center">
								<h2 className="heading">{t('comment')}</h2>
								<div className="col-md-4 col-sm-4 col-xs-12 text-center">
									<img src="images/ic-howitworks-01.png"/>
									<p>{t('prosp7')}</p>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-12 text-center">
									<img src="images/ic-howitworks-02.png"/>
									<p>{t('prosp8')}</p>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-12 text-center">
									<img src="images/ic-howitworks-03.png"/>
									<p>{t('prosp9')}</p>
								</div>
							</div>
						</div> 
					</section>
	


				 )
            }
      </I18n>

    	) 
   }
}

















/*
old 



			<section id="pros-intro-section">
					<div className="container">
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12">
								<div className="head-part">
									<h1>{t('prostitle')}</h1>
									<p className="hidden-xs">{t('proshead')}</p>
								</div>
							</div>
						</div>
						
							<div className="row desc-part">
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
									<div className="row">
										<div className="col-md-12 col-sm-12 col-xs-12 retailer-content">
												<p>{t('p1')}</p>
										</div>
									</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
									<div className="row"> 
										<div className="col-md-12 col-sm-12 col-xs-12 retailer-content">
											<p>{t('p2')}</p>
										</div>
									</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
									<div className="row">
										<div className="col-md-12 col-sm-12 col-xs-12 retailer-content">
											<p>{t('p3')}</p>
										</div>
									</div>	
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
									<div className="row">
										<div className="col-md-12 col-sm-12 col-xs-12 retailer-content">
											<p>{t('p4')}</p>
										</div>
									</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
									<div className="row">
										<div className="col-md-12 col-sm-12 col-xs-12 retailer-content">
											<p>{t('p5')}</p>
										</div>
									</div>
								</div>
								<div className="col-md-4 col-sm-6 col-xs-12 retailer-part">
									<div className="row">
										<div className="col-md-12 col-sm-12 col-xs-12 retailer-content">
											<p>{t('p6')}</p>
										</div>
									</div>
								</div>
							</div>
						
						<div className="row">
							<div className="col-md-12 col-sm-12 col-xs-12">
								<h3 className="btm-text">{t('prosfooter')}</h3>
							</div>
						</div>
					</div>
				</section>



*/





/*

<div className="col-md-6 col-sm-6 col-xs-12">
								<div className="row">
									<div className="col-md-12 col-sm-12 col-xs-12">
										<h3 className="heading">{t('proslefth1')}</h3>
										<h4 className="sub-heading">{t('prosleftpara1')}</h4>
										<ul className="content">
											<li>{t('prosleftpara2')}</li>
											<li>{t('prosleftpara3')}</li>
											<li>{t('prosleftpara4')}</li>
											<li>{t('prosleftpara5')}</li>
											<li>{t('prosleftpara6')}</li>
										</ul>
									</div>
								</div>
								<div className="row">
									<div className="col-md-12 col-sm-12 col-xs-12">
										<h3 className="heading">{t('proslefthead')} <span class="res-block">{t('proshead1')}</span></h3>
										<ul className="content">
											<li>{t('prosleftpara7')}</li>
											<li>{t('prosleftpara8')}</li>
											<li>{t('prosleftpara9')}</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="col-md-6 col-sm-6 col-xs-12">
								<div className="row">
									<div className="col-md-12 col-sm-12 col-xs-12">
										<h3 className="heading">{t('prosrighttitle')}</h3>
										<h4 className="sub-heading">{t('prosrightpara1')}</h4>
										<ul className="content">
											<li>{t('prosrightpara2')}</li>
											<li>{t('prosrightpara3')}<br/> {t('prosrightpara4')}</li>
											<li>{t('prosrightpara5')}</li>
											<li>{t('prosrightpara6')}</li>
										</ul>
									</div>
								</div>	
								<div className="row">
									<div className="col-md-12 col-sm-12 col-xs-12">
										<h3 className="heading">{t('prosrighthead')}<span className="res-block">{t('prosrighthead1')}</span></h3>
										<ul className="content">
											<li>{t('prosrightpara7')}</li>
											<li>{t('prosrightpara8')}</li>
										</ul>
									</div>
								</div>
							</div>*/


// WEBPACK FOOTER //
// ./src/components/Professionnel/Professionnels/Professionnels.js